module.exports = "/assets/854ec9aaeb281e6a5d43b7026645488f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LV.png
// module id = 1593
// module chunks = 0